import InvitePatientForm from "./InvitePatientForm";

export default InvitePatientForm;